export const DONUT_THICKNESS = 6;
export const DONUT_MARGIN = 12;
export const LEGEND_MARGIN = 40;
export const HOVER_DEBOUNCE_DELAY = 150;
